export default __webpack_public_path__ + "static/sprite-edea7b229b53776c555746ed03404d49.svg";